import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ExclusiveCollectionBadge } from 'Components/widgets/exclusive-collection-badge/ExclusiveCollectionBadge';
type Props = {
  className?: string;
  product: Product;
};
export const ProductBanner = ({ className, product }: Props) => (
  <div className={classnames('flex flex-col items-start text-black', className)}>
    <span
      className="order-last inline-flex flex-wrap items-center gap-5 font-sans text-20 font-semibold"
      data-testid="ProductBlockHeader-name"
    >
      {product.name}
      {product.isExplicitEC && <ExclusiveCollectionBadge className="md:mx-5" />}
      {product.seasonTrad && (
        <span className="shrink-0 whitespace-nowrap rounded-pill bg-turquoise px-10 py-5 text-center text-10 font-bold leading-1 text-white">
          {product.seasonTrad}
        </span>
      )}
    </span>
    <span
      className="truncate font-sans text-14 font-semibold text-sienna"
      data-testid="ProductBlockHeader-country"
    >
      {product?.destination?.country}
    </span>
  </div>
);
